import { render } from "./archive-warning.vue?vue&type=template&id=31030af9&lang=pug"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__